import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 28-search
 * @see {GlyphIcon}
 */
const SearchIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M27.207,24.37866,20.6106,17.78235a9.03069,9.03069,0,1,0-2.82825,2.82825L24.37878,27.207a1,1,0,0,0,1.41425,0l1.414-1.41418A1,1,0,0,0,27.207,24.37866ZM13,19a6,6,0,1,1,6-6A6.00657,6.00657,0,0,1,13,19Z";
	}
}

export default SearchIcon;
